const LogoUploadDescription = () => {
  return (
    <>
      <ul className="pe-3 mt-2 color-secondary">
        <li>
          <small className="color-gray-1">قالب مربع</small>
        </li>
        <li>
          <small className="color-gray-1">حداقل 600 در 600 پیکسل</small>
        </li>
        <li>
          <small className="color-gray-1">فرمت PNG یا JPG</small>
        </li>
      </ul>
    </>
  );
};

export default LogoUploadDescription;
